const default_addToCartText = "Add To Cart";
const default_addedToCartText = "Added to Cart!";
const default_add_all_to_cart_text = "Add All to Cart"
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";
const tangent_client_domain_url = window.location.origin;
let isApiCallDone = false;

// Tab title mapping based on tags
const tabs_title_mapping={
  section_simple:"Simple Routine",
  section_multiple:"Multi-step Routine"
}

// Product ID to single Variant ID mapping
let tangent_selected_product_map;
let recommendIDfetch = false;
let tangent_selfie_id;
let tangent_quiz_tags=[];
let tangent_facemap_data;

// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

// Message for each conditions
const condition_text_mapping = {
  dark_circles:"Prone to dark circles here!.",
  wrinkles:"Prone to wrinkles here!",
  rosacea:"Prone to rosacea here!",
  texture:"Prone to texture here!",
  darkspots:"Prone to darkspots here!",
  acne:"Prone to acne here!"
}

const defaultConcernText = {
  Wrinkles_Score_container:`
    <h2>Smooth Away Wrinkles for a Youthful Glow</h2>
    <p>Wrinkles are a sign of aging, but the right care can help reduce their appearance. Our anti-aging formula, enriched with retinol, peptides, and hyaluronic acid, works to boost collagen, smooth fine lines, and deeply hydrate your skin. Lightweight and fast-absorbing, it leaves your skin firmer, plumper, and more radiant. Try it today and reclaim your youthful glow!</p>
  `,
  Rosacea_Score_container:`
    <h2>Soothe and Calm Rosacea-Prone Skin</h2>
    <p>Rosacea can cause redness, irritation, and sensitivity, but the right care can help restore balance. Our gentle, dermatologist-approved formula is infused with calming ingredients like niacinamide, aloe vera, and chamomile to reduce redness, strengthen the skin barrier, and provide deep hydration. Lightweight and soothing, it helps your skin feel calm, comfortable, and refreshed. Try it today for a healthier, more even complexion!</p>
  `,
  DarkCircles_Score_container:`
    <h2>Brighten and Refresh Tired Eyes</h2>
    <p>Dark circles can make you look tired and aged, but the right care can restore brightness. Our advanced eye cream, infused with vitamin C, caffeine, and hyaluronic acid, works to reduce puffiness, lighten dark circles, and hydrate delicate under-eye skin. Lightweight and fast-absorbing, it revitalizes and refreshes your eyes for a more youthful, well-rested look. Try it today for brighter, radiant eyes!</p>
  `,
  Acne_Score_container:`
    <h2>Clear Skin, Confident You</h2>
    <p>Acne can be frustrating, but the right skincare can help you achieve a clearer complexion. Our powerful yet gentle formula, enriched with salicylic acid, tea tree oil, and niacinamide, works to unclog pores, reduce breakouts, and calm inflammation. Lightweight and fast-absorbing, it targets blemishes without over-drying, leaving your skin balanced, smooth, and refreshed. Try it today for clearer, healthier-looking skin!</p>
  `,
  DarkSpots_Score_container:`
    <h2>Fade Dark Spots for Radiant Skin</h2>
    <p>Dark spots and uneven skin tone can dull your complexion, but the right care can restore its glow. Our brightening formula, infused with vitamin C, niacinamide, and licorice extract, works to fade dark spots, even out skin tone, and enhance radiance. Lightweight and fast-absorbing, it leaves your skin brighter, smoother, and more luminous. Try it today for a clearer, more radiant complexion!</p>
  `,
  Texture_Score_container:`
    <h2>Smooth and Refine Your Skin Texture</h2>
    <p>Rough, uneven skin texture can make your complexion look dull, but the right care can help. Our skin-smoothing formula, enriched with AHAs, BHAs, and hyaluronic acid, works to gently exfoliate, refine pores, and boost hydration for a softer, more even texture. Lightweight and nourishing, it leaves your skin smooth, radiant, and refreshed. Try it today for a flawless, silky-smooth complexion!</p>
  `,
}

// Add default image url here
const tangent_default_selfie_image_url="https://cdn.shopify.com/s/files/1/0642/1299/2252/files/GlowScan-Skin_Analysis-31-EN.jpg";
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

let tangent_client_domain_currency;
const tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 
const tangent_condition_message_popoup = document.querySelector("#tangent-popup-condition-message"); 

function onLoadFunction(){
  const tangent_response_id = getClientResponseId();
  if (tangent_response_id != null) {
    const checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    doApiCall("recommendation",checkout_url); 
  }
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", (event) => {
        onLoadFunction();
    });
} else {
    onLoadFunction();
}

function getClientResponseId(){
  // Current Page Load URL
  var tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function doApiCall(type, url){
  fetch(url)
  .then(data => {
    return data.json();
  })
  .then(response => {
    checkoutDataProcess(response);
    return response;
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function checkoutDataProcess(response){
    let tangent_recommended_products = response.products;
    let selected_variants_map = response.selected_variants;
    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText+" "; 
  
    // Setting Default variant price symbol
    if (tangent_client_domain_currency != "$") {
        tangent_client_domain_currency = 'KWD';
    }
  
    // Setting selfie / default image
    setTangentSelfieSection(response);

    createTabButtons();
  
    // Initial Tab setting
    setTabOpen(response.tags);
  
    tangent_quiz_tags = response.tags;
  
    const tangent_product_sections = response.product_sections;
    const tangent_text_sections = response.text_sections;
  
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    
  
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
        setProductsToView(tangent_recommended_products, tangent_product_sections, selected_variants_map);
        enableButtonListener();
        loadElementsOnResponseData();  
        //fixPriceCurrencyForDefault();
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }

    if (response.description == '') {
      setElementDisplayById('tangent-general-text','block');
    }

    setupTabs();
}

/*function fixPriceCurrencyForDefault() {
  const currencyItem = document.querySelector('.ht-tms-dropdown__list-item__label[data-value="KW"]');

  if (!currencyItem) return; // Exit if Kuwait currency isn't found

  const currency = "KWD";
  const elementsToUpdate = [
    '.tangent-regular-price-on-sale',
    '.highlight-price',
    '.tangent-original-price'
  ];

  elementsToUpdate.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      // Avoid duplicate currency additions
      if (!el.textContent.includes(currency)) {
        el.textContent = el.textContent.trim() + ' ' + currency;
      }
    });
  });
}*/

// Utility function to scroll to a tab
const scrollToTab = (tabsContainer, tabButton) => {
    const position = tabButton.getBoundingClientRect();
    const scroll = tabsContainer.scrollLeft;
    tabsContainer.scrollTo({
        left: scroll + position.left - tabsContainer.offsetLeft - 30,
        behavior: 'smooth',
    });
};

// Utility function to hide all content divs
const hideAllTabContents = () => {
    document.querySelectorAll('.tabcontent').forEach(div => {
        div.style.display = 'none';
    });
};

// Utility function to show the corresponding content
const showTabContent = (tabButton) => {
    const targetDiv = document.querySelector(`#${tabButton.name}_main_container`);
    if (targetDiv) {
        targetDiv.style.display = 'block';
    }
};

// Utility function to update active class
const updateActiveTab = (tabButtons, activeButton) => {
    tabButtons.forEach(button => button.classList.remove('active'));
    activeButton.classList.add('active');
};

// Main logic for setting up tabs behaviour
const setupTabs = () => {
    const tabsContainer = document.querySelector('.tabcontent');
    const tabButtons = document.querySelectorAll('.tab button');
    tabButtons.forEach(tabButton => {
        tabButton.addEventListener('click', function () {
            // Scroll to the clicked tab
            scrollToTab(tabsContainer, this);
            
            // Hide all content divs and show the corresponding content
            hideAllTabContents();
            showTabContent(this);
          
            // Update active class for the tabs
            updateActiveTab(tabButtons, this);
        });
    });
};


function setProductsToView(products, sections, selected_variants) {
  tangent_selected_product_map = {};
  Object.keys(sections).forEach(section => {
    const product_ids = sections[section];
      let section_product_grid = document.getElementById(section+"-product-grid");
    
      let stepCount = 0;
      product_ids.forEach(id => {
        const product = products.find(p => String(p.id) === id);
        stepCount = stepCount +1;
        const product_html = getProductHTML(product, products.indexOf(product), section, selected_variants, stepCount);        
        if(product_html!=null){
           section_product_grid.innerHTML = section_product_grid.innerHTML + product_html;
        }
      });
  });
}

function getVariant(product, variant_id) {
  let variant_list = product.variants.edges;

  for (let index = 0; index < variant_list.length; index++) {
    if (getVariantIdValue(variant_list[index].node.id) == variant_id) {
      return variant_list[index].node;
    }
  }

  return variant_list[0].node; // Fallback to the first variant
}

function getDiscountPercent(tags) {
    let discount = null; // Store the last detected discount percentage

    for (let tag of tags) {
        let match = tag.match(/(\d+)(?=OFF)/);
        if (match) discount = Number(match[1]); // Update last detected discount
    }

    return discount; // Return the last found discount or null
}

function getVariantIdValue(vId){
  return Number(vId.replace("gid://shopify/ProductVariant/",""));
}

function getProductHTML(product, index, section, selected_variants, stepCount) {
  const variant = getVariantOfProduct(product, selected_variants);
  const variantId = getVariantIdValue(variant.id);
  tangent_selected_product_map[product.id] = variantId;

  const variantProductUrl = getVariantProductUrl(product, variantId);
  const productDetails = getProductDetails(product, variant);
  const { addButtonText, buttonClass } = getAddToCartState(product, variant, section, variantId);
  const addToCartButton = getAddToCartButton(section, index, variantId, addButtonText, buttonClass);
  return `
    <div>
      <h2 style="margin:0;margin-bottom:0%;">STEP ${stepCount}</h2>
      <div class="tangent-product-item">
        <div class="tangent-product-item-sub-container">
          <div class="tangent-product-image-section">
            <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variantProductUrl}">
              ${getProductImage(index, productDetails.imageUrl, productDetails.title)}
            </a>
          </div>
          <div  class="tangent-product-details-section">
            <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variantProductUrl}">
              ${getProductInfo(product)}
            </a>
            ${getPriceHTML(productDetails.price, productDetails.discountedPrice)}
            <div id="${section}_variant_${index}" class="tangent-product-variant"></div>
            <p class="tangent-product-add-button-wrapper tangent-btn-add tangent-add-to-cart-button ${buttonClass}" id="${section}_cart_tangent_product_${index}_text" 
            data-variantId="${variantId}">
                ${addButtonText}
            </p>
          </div>
        </div>
      </div>
    </div>
  `;
}

function getVariantProductUrl(product, variantId) {
  return `${product.onlineStoreUrl}?variant=${variantId}`;
}

function getProductDetails(product, variant) {
  return {
    title: product.title,
    price: variant.price,
    imageUrl: getVariantImage(variant),
    discountedPrice: getFinalPrice(variant.price, product.tags),
  };
}

function getAddToCartState(product, variant, section, variantId) {
  if (!isProductAvailable(product, variant)) {
    return { addButtonText: out_of_stock_text, buttonClass: 'disable-btn-wrapper' };
  }
  updateAddToCartSectionsMap(section, variantId);
  return { addButtonText: default_addToCartText, buttonClass: '' };
}

function getProductImage(index, imageUrl, title) {
  return `
    <div class="tangent-product-image-container">
      <img id="image_tangent_product_${index}" src="${imageUrl}" class="tangent-product-image" alt="${title}">
    </div>
  `;
}

function getProductInfo(product) {
  return `
    <p class="card-information__text h4 tangent-product-vendor">${product.vendor}</p>
    <p class="tangent-product-title tangent-product-title-text caption-with-letter-spacing">
      ${product.title}
    </p>
  `;
}

function getAddToCartButton(section, index, variantId, addButtonText, buttonClass) {
  return `
    <p class="product-form__submit button button--full-width rbr tangent-product-add-btn-wrapper tangent-btn-add tangent-add-to-cart-button ${buttonClass}" id="${section}_cart_tangent_product_${index}_text" 
    data-variantId="${variantId}">
        ${addButtonText}
    </p>
  `;
}


function getPriceHTML(originalPrice, discountedPrice){
    let formattedOriginalPrice = originalPrice;
    let formattedDiscountedPrice = discountedPrice;
    let currency = tangent_client_domain_currency;

    // If discounted price is different, strike through original price
    if (originalPrice !== discountedPrice) {
        return `
        <p class="notranslate tangent-product-price-text price price--on-sale price-item--sale" htmoney>
          <span class="price-item--regular tangent-regular-price-on-sale price notranslate" htmoney="">${formattedOriginalPrice}</span>
          <span class="highlight-price price notranslate" htmoney="">${formattedDiscountedPrice} KWD</span>
        </p>`;
    } else {
        return `
        <p class="notranslate tangent-product-price-text tangent-original-price price" htmoney>
          ${formattedOriginalPrice} KWD
        </p>`;
    }
}

function getFinalPrice(originalPrice, tags) {
    let discountPercent = getDiscountPercent(tags);
    return calculateDiscountedPrice(originalPrice, discountPercent);
}

function calculateDiscountedPrice(originalPrice, discountPercent) {
    return discountPercent !== null 
        ? originalPrice - (originalPrice * discountPercent / 100)
        : originalPrice;
}

function getVariantOfProduct(product, selected_variants){
  const products_variant_list = selected_variants[product.id] || [];
  const hasSelectedVariants = products_variant_list.length > 0;
  
  let variant = hasSelectedVariants 
    ? getVariant(product, products_variant_list[0]) 
    : product.variants.edges[0].node;

  return variant;
}

function isProductAvailable(product, variant) {
  // Check if the product is active
  if (product.status !== "ACTIVE") {
    return false;
  }
  // Product is available
  return variant.availableForSale;
}

function setTabOpen(tags) {
  const tabWrapper = document.querySelector("#tab-wrapper");
  const tabContents = document.querySelectorAll(".tabcontent");
  const tabLinks = document.querySelectorAll(".tablinks");

  // Show tab wrapper
  tabWrapper.style.display = "block";

  // Determine the default tab index based on tags
  let tabIndex = 0;
  if (tags.includes("multi_routine")) {
    tabIndex = 1;
  }

  // Hide all tab content and remove 'active' class from all links
  tabContents.forEach(tab => tab.style.display = "none");
  tabLinks.forEach(link => link.classList.remove("active"));

  // Show the appropriate tab content and activate the corresponding tab link
  tabContents[tabIndex].style.display = "flex";
  tabLinks[tabIndex].classList.add("active");
}

function createTabButtons(){
  for (var section in tabs_title_mapping) {
   createTabButton(section)    
  }
}

function updateAddToCartSectionsMap(section, variant_id){
  if (sections_add_to_cart_map[section]) {
    const sectionData = sections_add_to_cart_map[section];
    if (!sectionData.list.includes(variant_id)) {
      sectionData.count++;
      sectionData.cart_link += `&id[]=${variant_id}`;
      sectionData.list.push(variant_id);
    }
    
  } else {
    sections_add_to_cart_map[section] = {
      count: 1,
      cart_link: `${tangent_client_domain_url}/cart/add?id[]=${variant_id}`,
      list: [variant_id],
    };
  } 
}

// Custom function - Adding meta properties to add to cart function call
function addAllToCartFunction(button){
  let sectionName = button.getAttribute("data-sectionName");
  let productData = getProductData(sectionName);
  const miniCart = document.querySelector('mini-cart');
  const sections = miniCart ? miniCart.getSectionsToRender().map((section) => section.id) : [];
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({...productData, 'sections': sections, 'sections_url': window.location.pathname})
  })
  .then(response => {
    document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
    document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    })); 
    return response.json();
  }).then((parsedState) => {
    // Open cart drawer
    miniCart && miniCart.renderContents(parsedState);
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: parsedState
      }
    }));
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

const getVariantImage = (variant) => {
    return variant.image.url ? variant.image.url : 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
}

// Add To Cart Function
// Custom function - Adding meta properties to add to cart function call
function addToCartFunction(cartButton){ 
  let variantId = Number(cartButton.getAttribute("data-variantId"));
  console.log(variantId);
  if(cartButton){

    const miniCart = document.querySelector('mini-cart');
    const sections = miniCart ? miniCart.getSectionsToRender().map((section) => section.id) : [];
    
    let formData = {
     'items': [{
      'id': variantId,
      'quantity': 1,
      'properties': {
        '_type': 'tangent-quiz'
      }
      }],
      'sections': sections,
      'sections_url': window.location.pathname
    };
    console.log(formData);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      cartButton.innerHTML = default_addedToCartText;
      cartButton.classList.add("added-to-cart-style"); 
      showMessage("ADDED TO CART!");
      document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
      document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
      }));
      return response.json();
    }).then((parsedState) => {
      // Open cart drawer
      miniCart && miniCart.renderContents(parsedState);
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: parsedState
        }
      }));
    }).catch((error) => {
      console.error('Error:', error);
    });
  }
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    return section_container;
}

// Add to cart button for sections
function createSectionAddAllToCart(section_name) {

    var add_all_to_cart_p_tag = document.createElement("p");
    add_all_to_cart_p_tag.id = section_name+"-add-all-to-cart";
    add_all_to_cart_p_tag.classList.add("section-add-all-to-cart");
    add_all_to_cart_p_tag.classList.add(section_name+"-add-all-to-cart");
    add_all_to_cart_p_tag.setAttribute('data-sectionName', section_name);
  
    var add_all_cart_link = document.createElement("a");
    add_all_cart_link.id = section_name+"-add-all-cart-link";
    add_all_cart_link.classList.add("section-add-all-cart-link");
    add_all_cart_link.classList.add(section_name+"-add-all-cart-link");
    add_all_cart_link.innerHTML = default_add_all_to_cart_text;
  
    add_all_to_cart_p_tag.appendChild(add_all_cart_link);
  
    return add_all_to_cart_p_tag;
}

// Custom function - Adding meta properties to add to cart function call
function addAllToCartFunction(button){
  let sectionName = button.getAttribute("data-sectionName");
  let productData = getProductData(sectionName);

  const miniCart = document.querySelector('mini-cart');
  const sections = miniCart ? miniCart.getSectionsToRender().map((section) => section.id) : [];
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({...productData, 'sections': sections, 'sections_url': window.location.pathname})
  })
  .then(response => {
    showMessage("ADDED ALL TO CART!");
    document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
    document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    })); 
    return response.json();
  }).then((parsedState) => {
    // Open cart drawer
    miniCart && miniCart.renderContents(parsedState);
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: parsedState
      }
    }));
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"-product-grid";
    product_grid_view_container.classList.add("section-product-grid");
    product_grid_view_container.classList.add(section_name+"-product-grid");
    return product_grid_view_container;
}

// Tab buttons 
function createTabButton(section_name) {
    var tab_button = document.createElement("button");
    tab_button.id = section_name+"_tab_button";
    tab_button.innerHTML = getTabTitle(section_name);
    tab_button.name = section_name;
    tab_button.classList.add("tablinks");
    tangent_custom_tabs.appendChild(tab_button);
}

function getTabTitle(section){
  var tab_title;
  if(tabs_title_mapping[section]!=undefined){
    tab_title = tabs_title_mapping[section];
  }
  else{
    tab_title = section.replace("section_","").replace("_"," ").toUpperCase();
  }
  return tab_title;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    const section_simple_container = document.querySelector("#section_simple_main_container");
    const section_multiple_container = document.querySelector("#section_multiple_main_container");
  
    for (const section_name in product_sections) {
        // The created container will have both a container to show text and products
        var section_container = createSectionContainer(section_name);    
        
        // Creating text sections before products sections if exists
        if(text_sections!=undefined){
            createTextSectionBeforeProducts(text_sections,section_container,section_name);
        }    
        // Creating section to add all products
        section_container.appendChild(addSectionProductGridContainer(section_name));

        //const static_text = `<p>GET YOUR ENTIRE REGIMEN & SAVE 15% by using code <b>GLOWSKIN15</b></p>`
        const static_text = `<div class="tangent_discount_code_container" style="display: block !important;"> <p class="discount_code">ENTER CODE: GLOWSKIN15 AT CHECKOUT</p>  <p class="discount_code_subttext" style="display: block !important">For 15% off on your custom routine</p>`
        section_container.appendChild(createCustomHTMLContent(section_name,static_text));
      
        // Creating add all to cart button for the section    
        section_container.appendChild(createSectionAddAllToCart(section_name));
        
        if(section_name.includes("section_simple")){
          section_simple_container.appendChild(section_container);          
        }
        else{
          section_multiple_container.appendChild(section_container); 
        }
    }
}

function cloneAndAppend(container, prefix, targetContainer) {
    let clonedContainer = container.cloneNode(true);
    let targetChild = clonedContainer.children[1] || clonedContainer.children[0];

    if (targetChild) {
        targetChild.id = `${prefix}_${targetChild.id}`;
        targetContainer.appendChild(clonedContainer);
    }
}

function createCustomHTMLContent(section, content){
  var customContent = document.createElement("div");
  customContent.classList.add("section-custom-content");
  customContent.classList.add(section+"-custom-content");
  customContent.innerHTML = content;
  return customContent;
}

// Add to cart button for sections
function createSectionAddAllToCart(section_name) {
    var add_all_to_cart_p_tag = document.createElement("p");
    add_all_to_cart_p_tag.id = section_name+"-add-all-to-cart";
    add_all_to_cart_p_tag.classList.add("section-add-all-to-cart");
    add_all_to_cart_p_tag.classList.add(section_name+"-add-all-to-cart");
    add_all_to_cart_p_tag.setAttribute('data-sectionName', section_name);
  
    var add_all_cart_link = document.createElement("a");
    add_all_cart_link.id = section_name+"-add-all-cart-link";
    add_all_cart_link.classList.add("section-add-all-cart-link");
    add_all_cart_link.classList.add(section_name+"-add-all-cart-link");
    add_all_cart_link.innerHTML = default_add_all_to_cart_text;
  
    add_all_to_cart_p_tag.appendChild(add_all_cart_link);
  
    return add_all_to_cart_p_tag;
}

const getProductData = (sectionName) => {
  const sectionVariantList= sections_add_to_cart_map[sectionName].list;
  const allVariantList = Object.values(tangent_selected_product_map);
  let productData = {
   'items': []
  };
  for (let variantId of sectionVariantList) {
    let item = {
      'id': variantId,
      'quantity': 1,
      'properties': {
        '_type': 'tangent-quiz'
      }
    }
    productData.items.push(item);
  }
  return productData;
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section-text-container");
        section_div.classList.add(section_name+"-text-container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"-text-container";
            section_div.classList.add("section-text-container");
            section_div.classList.add(section_name+"-text-container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_container.classList.remove('tabcontent'); 
              section_selfie.appendChild(section_container);
            }
            else{
              // Add to main container wrapper
              tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

const setElementDisplayById = (elementId, displayStyle) => {
  const element = document.getElementById(elementId);
  if (element) {
      element.style.display = displayStyle;
  }
}


// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
  // API call for facemapping
  if(response["selfie_id"]!=null){
    setSelfieId(response["selfie_id"]);
    getSelfieMapping(response["selfie_id"]);
    enableSelfieDependedStaticElements();
  }
  else{
    const canvasImg = document.querySelector('#canvas_img');
    setElementDisplayById('canvas_img','block');
    
    setElementDisplayById("loading-section", "none");
    setElementDisplayById("tangent_score_description", "none");
    
    if(response.selfie_url!=undefined && response.selfie_url!=null){
      if (canvasImg) {
          canvasImg.src = response.selfie_url;
      }
    }
    else{
    if(tangent_default_selfie_image_url!=""){
      if (canvasImg) {
        canvasImg.style.width="100%";
        canvasImg.src = tangent_default_selfie_image_url;
        
        applySelfieSectionStyles();
      }
    }
    else{
      setElementDisplayById('image-parent-container','none');
      setElementDisplayById("tangent_selfie_container","none");
    }
  }   
  }
}

function applySelfieSectionStyles() {
  const selfieWrapper = document.getElementById("tangent_section_selfie_parent_wrapper");
  const imageContainer = document.getElementById("image-parent-container");

  if (selfieWrapper) {
    Object.assign(selfieWrapper.style, {
      width: "100%",
      margin: "0",
      background: "none"
    });
  }

  if (imageContainer) {
    Object.assign(imageContainer.style, {
      maxWidth: "unset",
      padding: "0"
    });
  }
}

const setConcernStaticContent = (id) => {
  setElementDisplayById("tangent-concern-default-text-container","block");
  document.getElementById("tangent-concern-default-text-container").innerHTML =defaultConcernText[id];
}

function showConcernDetails(selected){
  const allScoreButtons = document.querySelectorAll('.facemap_score');
  
  allScoreButtons.forEach(button => {
    if(button.id==selected.id){
      button.classList.add(button.id+"_active");
    }
    else{
      button.classList.remove(button.id+"_active");
    }
  });

  setConcernStaticContent(selected.id);
}



// Enabling button listeners
function enableButtonListener() {
  // Listener for "Add to Cart" buttons
  const productCartButtons = document.querySelectorAll('.tangent-product-add-button-wrapper');
  productCartButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      addToCartFunction(this);
    }, false);
  });

  // Listener for "Add to Cart" buttons
  const allCartBtns = document.querySelectorAll('.section-add-all-to-cart');
  
  allCartBtns.forEach(button => {
    button.addEventListener('click', function(event) {
      addAllToCartFunction(this);
    }, false);
  });
  
  // * Disabled Temporarily *
  // const allScoreButtons = document.querySelectorAll('.facemap_score');
  // allScoreButtons.forEach(button => {
  //   button.addEventListener('click', function(event) {
  //     showConcernDetails(this);
  //   }, false);
  // });
  
}

const loadElementsOnResponseData = () => {
    const allElements = document.querySelectorAll('.load-on-data');
    allElements.forEach(element => {
        element.style.display = "block";
    });
};

const showMessage = (message) => {
  const _snackbar = document.getElementById("tangent-message-snackbar");
  _snackbar.innerHTML = message;
  _snackbar.className = "show";

  // After 3 seconds, remove the show class from DIV
  setTimeout(function(){ _snackbar.className = _snackbar.className.replace("show", ""); }, 3000);
}

// Selfie Mapping data api call
function getSelfieMapping(selfie_id){
   var selfie_api_url = "https://service.tangent.ai/shopify/upload-selfie?selfie_id="+selfie_id+"&user=mango" 
   var xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        var DONE =  (typeof XMLHttpRequest.DONE !== 'undefined') ? XMLHttpRequest.DONE : 4;
        if (xmlhttp.readyState == DONE) { 
            if (xmlhttp.status == 200) {
              var response_json = JSON.parse(xmlhttp.responseText);
              tangent_facemap_data = response_json["selfie_record"][0].facemap;
              if(tangent_facemap_data!=undefined){
                setScores(tangent_facemap_data.scores);
                document.querySelector("#canvas_img").setAttribute("src",tangent_facemap_data.url);
              }
             
              setElementDisplayById("loading-section", "none");
              setElementDisplayById("canvas_img", "block");
            }
            else if (xmlhttp.status == 400) {
                console.log('There was an error 400');
            }
            else {
                console.log('Something else other than 200 was returned');
            }
        }
    };

    xmlhttp.open("GET", selfie_api_url, true);
    xmlhttp.send();
}


// Toggle hide highlight and show highlight
function toggleHighlight(status){
  if(status){
    setElementDisplayById('image-parent-container','flex');
    setElementDisplayById('hideHighlight','block');
    setElementDisplayById('showHighlight','none');
    setElementDisplayById('selfie_canvas','block');
  }
  else{
    setElementDisplayById('hideHighlight','none');
    setElementDisplayById('showHighlight','block');
    setElementDisplayById('selfie_canvas','none');
  }
}

function setBorderFill(el, value, max = 10) {
  const percent = (value / max) * 10;
  el.style.setProperty('--value', percent);
}

// Setting scores below the selfie
function setScores(scores) {
  const concernMap = {
    acne: "Acne",
    rosacea: "Rosacea",
    darkspots: "DarkSpots",
    wrinkles: "Wrinkles",
    dark_circles: "DarkCircles",
    texture: "Texture",
  };

  let scores_present = false;

  Object.keys(scores).forEach(key => {
    if (concernMap[key]) {
      const containerId = `${concernMap[key]}_Score_container`;
      const scoreId = `#${concernMap[key]}_Score`;

      setElementDisplayById(containerId, "flex");
      const circle = document.getElementById(containerId);
      setBorderFill(circle, scores[key]); 
      document.querySelector(scoreId).innerHTML = scores[key]/10;
      scores_present = true;
    }
  });

  // Show facemap container only if at least one concern is found
  setElementDisplayById("facemap_all_scores_container", scores_present ? "flex" : "none");
}

function enableSelfieDependedStaticElements(){
  setElementDisplayById("tangent_score_description", "block");
  setElementDisplayById("skin-health-title-container", "block");
  setElementDisplayById("hideHighlight", "block");
}

function setSelfieId(id){
  tangent_selfie_id = id;
}

function getSelfieId(){
  return tangent_selfie_id;
}

// Getting current canvas click position
function getCursorPosition(canvas, event) {
  const ctx = canvas.getContext( '2d' );
  const bb = canvas.getBoundingClientRect();
  
  var point = {
    _x:Math.floor((event.clientX - bb.left) / bb.width * canvas.width),
    _y:Math.floor((event.clientY - bb.top) / bb.height * canvas.height)
  }
  
  var skin_conditions = ["acne","darkspots","wrinkles","dark_circles","rosacea"];
  var click_found = false;

  let tangent_selfie_container = document.getElementById("tangent_selfie_container")
  let offset_x = (bb.width - tangent_selfie_container.clientWidth)/2;
  
  var popup_location = {
    _x: event.clientX - bb.left - offset_x,
    _y: event.clientY - bb.top
  }
  
  for(var sc=0;sc <skin_conditions.length;sc++){
    if(isPointInsidePoligon(point,tangent_facemap_data[skin_conditions[sc]])){
      openConditionMessage(canvas,skin_conditions[sc], popup_location);
      click_found=true;
      break;
    }
  }
  if(!click_found){
    tangent_condition_message_popoup.style.display="none";
    console.log("no condition click");
  }
}

function openConditionMessage(canvas, condition, point){
  tangent_condition_message_popoup.innerHTML = condition_text_mapping[condition];
  let rect = canvas.getBoundingClientRect();
  
  // Positioning Popup
  Object.assign(
    tangent_condition_message_popoup.style,
    {
      display:"block",
      left:(point._x) +"px",
      top:(point._y) +"px"
    }
  );
}

// Check whether click is inside condition points
function  isPointInsidePoligon(pt, points_list) {
  // https://stackoverflow.com/a/29915728/960654
  // ray-casting algorithm based on
  // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html
    
  var x = pt._x,
    y = pt._y

  var inside = false;
  for(var c=0;c<points_list.length;c++){
    var points = points_list[c];
    for (var i = 0, j = points.length - 1; i < points.length; j = i++) {
      var xi = points[i][0],
        yi = points[i][1]
      var xj = points[j][0],
        yj = points[j][1]

      var intersect =
        yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
      if (intersect) inside = !inside
    }
  }
  return inside
}


// Called on image on load function
function drawOnCanvas(){
    if(getSelfieId()!=null){
      
      var selfie_canvas = document.querySelector('#selfie_canvas');
      var selfie_canvas_ctx = selfie_canvas.getContext('2d');
      
      selfie_canvas.addEventListener('click', function(e) {
          getCursorPosition(selfie_canvas, e)
      });
      
      var canvas_img = document.querySelector('#canvas_img');
      setCanvasDimensions(selfie_canvas, canvas_img);
      
      var prop = getImageSize(canvas_img.naturalWidth);
      
      drawDarkCircleContours(selfie_canvas_ctx, tangent_facemap_data["dark_circles"], getDarkCircleBlur(prop));
      drawWrinkleContours(selfie_canvas_ctx, tangent_facemap_data["wrinkles"], getWrinkleLineWidth(prop));
      drawRosaceaContours(selfie_canvas_ctx, tangent_facemap_data["rosacea"], getRosaceaBlur(prop));
      drawTextureContours(selfie_canvas_ctx, tangent_facemap_data["texture"], getTextureLineWidth(prop));
      drawDarkSpotsContours(selfie_canvas_ctx, tangent_facemap_data["darkspots"], getDarkSpotsLineWidth(prop));
      drawAcneContours(selfie_canvas_ctx, tangent_facemap_data["acne"],getAcneLineWidth(prop));
    }
}

const setCanvasDimensions = (selfie_canvas, canvas_img) => {
  selfie_canvas.width  = canvas_img.naturalWidth;
  selfie_canvas.height = canvas_img.naturalHeight;
}

const getImageSize = (imgWidth) => {
  var prop =  imgWidth/400;
  return prop;
}

const getDarkCircleBlur = (prop) => {
  if(prop<1){
    return 'blur(1px)';
  }
  else if(prop<1.5){
    return 'blur(2px)';
  }
  else if(prop<2){
    return 'blur(4px)';
  }
  else if(prop<3){
    return 'blur(7px)';
  }
  else if(prop<4){
    return 'blur(12px)';
  }
  else{
    
  }
}

const getRosaceaBlur = (prop) => {
  if(prop<1){
    return 'blur(4px)';
  }
  else if(prop<1.5){
    return 'blur(4px)';
  }
  else if(prop<2){
    return 'blur(5px)';
  }
  else if(prop<3){
    return 'blur(13px)';
  }
  else if(prop<4){
    return 'blur(18px)';
  }
  else{
    console.log("out of bound props - Rosacea");
  }
}

const getAcneLineWidth = (prop) => {
  if(prop<0.5){
    return 2;
  }
  else if(prop<1){
    return 4;
  }
  else if(prop<1.5){
    return 7;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 15;
  }
  else{
    console.log("out of bound props - Acne");    
  }
}

const getDarkSpotsLineWidth = (prop) => {
  if(prop<1){
    return 1;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 6;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 15;
  }
  else{
    console.log("out of bound props - DarkSpots");    
  }
}

const getTextureLineWidth = (prop) => {
  if(prop<0.5){
    return 2;
  }
  else if(prop<1){
    return 3;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 14;
  }
  else if(prop<4){
    return 16;
  }
  else{
    return 20;
  }
}

const getWrinkleLineWidth = (prop) => {
  if(prop<1){
    return 4;
  }
  else if(prop<1.5){
    return 6;
  }
  else if(prop<2){
    return 10;
  }
  else if(prop<3){
    return 15;
  }
  else if(prop<4){
    return 30;
  }
  else{
    console.log("out of bound props - Wrinkle");    
  }
}

const drawDarkCircleContours = (context, eye_contours, filter) => {
  context.filter = filter;
  context.fillStyle = 'rgba(28, 30, 82, 0.3)';
  drawContours(context, eye_contours, true, false);
}

const drawWrinkleContours = (context, wrinkle_contours, lineWidth) => {
  context.fillStyle = 'rgba(24, 96, 3, 0.5)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(24, 96, 3, 0.5)";
  drawContours(context, wrinkle_contours, true, true);
}

const drawRosaceaContours = (context, eye_contours, filter) => {
  context.filter = filter;
  context.fillStyle = 'rgba(206, 66, 66, 0.5)';
  drawContours(context, eye_contours, true, false);
}

const drawTextureContours = (context, eye_contours, lineWidth) => {
  context.lineWidth = lineWidth;
  context.filter = 'none';
  context.strokeStyle = "rgba(186, 111, 223, 0.5)";
  drawContours(context, eye_contours, false, true);
}

const drawDarkSpotsContours = (context, darkspots_contours, lineWidth) => {
  context.fillStyle = 'rgba(81, 212, 191, 0.4)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(81, 212, 191, 0.4)";
  drawContours(context, darkspots_contours, true, false);
}

const drawAcneContours = (context, acne_contours, lineWidth) => {
  context.fillStyle = 'rgba(234, 220, 96, 0.4)';
  context.lineWidth = lineWidth;
  context.strokeStyle = "rgba(234, 220, 96, 0.4)";
  drawContours(context, acne_contours, true, false);
}

const drawContours = (context, contours, fill, stroke) => {
  for (let i = 0; i < contours.length; i++) {
    drawContour(context, contours[i], fill, stroke)
  }
}

const drawContour = (context, contour_coordinates, fill=false, stroke=false) => {
  context.beginPath();
  for (let i = 0; i < contour_coordinates.length; i++) {
    let point = contour_coordinates[i]
    if (i == 0) {
      context.moveTo(point[0], point[1]);
    } else {
      context.lineTo(point[0], point[1]);
    }
  }
  context.closePath();
  if (fill) context.fill();
  if (stroke) context.stroke();
}
